import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import {
  useActiveShippingUnit,
  useDeleteShippingUnit,
  useListShippingUnit,
} from "hooks";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setListShippingUnitColumn } from "store/actions";
import DetailShippingUnit from "./DetailShippingUnit";
import {
  getInitShippingUnitParams,
  shippingUnitModeList,
  shippingUnitRecordStatus,
  shippingUnitRecordStatusMode,
} from "./utils";

const ListShippingUnit = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["shippingUnit"]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  // Detail Shipping Unit Modal
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  // Delete Shipping Unit Modal
  const [dataDeleteShippingUnit, setDataDeleteShippingUnit] = useState({
    shippingUnitId: null,
  });
  const [deleteShippingUnitModal, setDeleteShippingUnitModal] = useState(false);

  // Active Shipping Unit Modal
  const [dataActiveShippingUnit, setDataActiveShippingUnit] = useState({
    shippingUnitId: null,
  });
  const [activeShippingUnitModal, setActiveShippingUnitModal] = useState(false);

  const {
    list: { columnsVisible: shippingUnitColumnsVisible },
  } = useSelector(state => state.shippingUnit);

  // List Shipping Unit
  const [shippingUnitParams, setShippingUnitParams] = useState(
    getInitShippingUnitParams
  );
  const {
    isLoading,
    data: shippingUnitList,
    refetch: listShippingUnit,
  } = useListShippingUnit({ params: shippingUnitParams });

  // Active Shipping Unit
  const handleActiveShippingUnit = () => {
    listShippingUnit();
  };
  const { mutate: activeShippingUnit } = useActiveShippingUnit(
    handleActiveShippingUnit,
    handleActiveShippingUnit
  );

  // Delete Shipping Unit
  const handleDeleteShippingUnit = () => {
    listShippingUnit();
  };
  const { mutate: deleteShippingUnit } = useDeleteShippingUnit(
    handleDeleteShippingUnit,
    handleDeleteShippingUnit
  );

  useEffect(() => {
    if (shippingUnitParams && shippingUnitParams.run) {
      listShippingUnit();
    }
  }, [shippingUnitParams]);

  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    setShippingUnitParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
    }));

    initColumn();
  }, [t]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (shippingUnitList) {
      initColumn();
    }
  }, [shippingUnitList]);

  const initColumn = () => {
    if (
      shippingUnitColumnsVisible &&
      Object.keys(shippingUnitColumnsVisible).length > 0
    ) {
      initColumns.forEach(item => {
        if (shippingUnitColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !shippingUnitColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListShippingUnitColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "record_status":
        if (prefix === "shipping_unit") {
          options = shippingUnitRecordStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    // Set option to select with Array values defined
    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    // Use For Column Formatter
    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "record_status":
        if (prefix === "shipping_unit") {
          options = shippingUnitRecordStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setShippingUnitParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : shippingUnitParams.sort,
      columnFilter: columnFilter || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const onSearchAllHandle = value => {
    setShippingUnitParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const toggleDeleteShippingUnitModal = () => {
    setDeleteShippingUnitModal(!deleteShippingUnitModal);
  };
  const clickDeleteShippingUnitHandler = (row, index) => {
    setDataDeleteShippingUnit({ shippingUnitId: row.id });
    toggleDeleteShippingUnitModal();
  };
  const deleteSingleShippingUnitHandler = () => {
    deleteShippingUnit({
      shippingUnitId: dataDeleteShippingUnit.shippingUnitId,
    });
    toggleDeleteShippingUnitModal();
  };

  const toggleActiveShippingUnitModal = () => {
    setActiveShippingUnitModal(!activeShippingUnitModal);
  };
  const clickActiveShippingUnitHandler = (row, index) => {
    setDataActiveShippingUnit({ shippingUnitId: row.id });
    toggleActiveShippingUnitModal();
  };
  const activeSingleShippingUnitHandler = () => {
    activeShippingUnit({
      shippingUnitId: dataActiveShippingUnit.shippingUnitId,
      data: {},
    });
    toggleActiveShippingUnitModal();
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
    switch (modeSet) {
      case shippingUnitModeList.EDIT_SHIPPING_UNIT_DETAIL:
        listShippingUnit();
        break;
      default:
        break;
    }
  };

  const clickEditShippingUnitHandler = (row, index) => {
    setDataDetail({ shippingUnitId: row.id });
    setMode(shippingUnitModeList.EDIT_SHIPPING_UNIT_DETAIL);
    toggleDetailModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail({ shippingUnitId: row.id });
      setMode(shippingUnitModeList.VIEW_SHIPPING_UNIT_DETAIL);
      toggleDetailModal();
    },
  };

  const listRowAction = [
    {
      // actionAccess: actionAccess.UPDATE_JOB_TITLE,
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.edit.shipping_unit"),
      onClick: clickEditShippingUnitHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      icon: <i className="fas fa-lock fa-lg text-danger" />,
      text: t("table.actions.delete.shipping_unit"),
      conditionVisible: {
        record_status: [shippingUnitRecordStatusMode.ACTIVE],
      },
      onClick: clickDeleteShippingUnitHandler,
    },
    {
      // actionAccess: actionAccess.ACTIVE_JOB_TITLE,
      icon: <i className="fas fa-lock-open fa-lg text-success" />,
      text: t("table.actions.active.shipping_unit"),
      conditionVisible: {
        record_status: [shippingUnitRecordStatusMode.INACTIVE],
      },
      onClick: clickActiveShippingUnitHandler,
    },
  ];

  const listMultipleRowAction = [];

  const initColumns = [
    {
      dataField: "name",
      text: t("table.name"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.name"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "phone_number",
      text: t("table.phone_number"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.phone_number"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "address",
      text: t("table.address"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.address"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "ward_code",
      text: t("table.ward_code"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.ward_code"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "district_code",
      text: t("table.district_code"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.district_code"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "province_code",
      text: t("table.province_code"),
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.province_code"),
        }),
      }),
      sort: true,
      allowExport: true,
    },
    {
      dataField: "record_status",
      text: t("table.record_status.shipping_unit.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.record_status.shipping_unit.name"),
        }),
        options: selectOptionsTable(
          undefined,
          "record_status",
          "shipping_unit"
        ),
      }),
      formatter: (cell, row) => {
        // "some" return boolean
        if (cell && shippingUnitRecordStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "record_status", "shipping_unit");
        } else {
          return ""; // Set Empty If Value Not Match
        }
      },
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={shippingUnitParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: true,
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      allowExport: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={shippingUnitParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.checker_id"),
        }),
      }),
      allowExport: true,
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${shippingUnitList?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.list") },
            ]}
          />

          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Detail Shipping Unit Modal */}
              <DetailShippingUnit
                dataDetail={dataDetail}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                mode={mode}
              />
              {/* Delete Shipping Unit Modal */}
              <ConfirmModal
                isOpen={deleteShippingUnitModal}
                titleHeader={t(
                  "form.submit.delete.shipping_unit.confirm.header"
                )}
                titleBody={t("form.submit.delete.shipping_unit.confirm.body")}
                onConfirm={deleteSingleShippingUnitHandler}
                textBtnConfirm={t(
                  "form.submit.delete.shipping_unit.confirm.agree"
                )}
                textBtnCancel={t(
                  "form.submit.delete.shipping_unit.confirm.cancel"
                )}
                toggle={toggleDeleteShippingUnitModal}
              />
              {/* Active Shipping Unit Modal */}
              <ConfirmModal
                isOpen={activeShippingUnitModal}
                titleHeader={t(
                  "form.submit.active.shipping_unit.confirm.header"
                )}
                titleBody={t("form.submit.active.shipping_unit.confirm.body")}
                onConfirm={activeSingleShippingUnitHandler}
                textBtnConfirm={t(
                  "form.submit.active.shipping_unit.confirm.agree"
                )}
                textBtnCancel={t(
                  "form.submit.active.shipping_unit.confirm.cancel"
                )}
                toggle={toggleActiveShippingUnitModal}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    // selectRow={selectRowCheckbox}
                    keyField="id"
                    data={shippingUnitList?.items || []}
                    columns={columnsTable}
                    page={shippingUnitParams.page}
                    sizePerPage={shippingUnitParams.sizePerPage}
                    totalSize={shippingUnitList?.totalCount || 0}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={listRowAction}
                    loading={isLoading}
                  >
                    <Link
                      to="/shipping-unit/create"
                      className="btn btn-primary btn-label"
                    >
                      <i className="fas fa-plus label-icon" />
                      {t("title.create")}
                    </Link>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListShippingUnit;
